export enum ArrangementGroupTarget {
  NotSpecified = 0,
  EA = 1,
  DippedFruit = 2,
  Mobile = 3,
}

export type ArrangementGroupTargets =
  typeof ArrangementGroupTarget[keyof typeof ArrangementGroupTarget];
